import React from "react";
import { useParams } from "react-router-dom";
import BlogPost from "../components/BlogPost/BlogPost";
import { fetchData } from "../api";
import { useQuery } from "react-query";
import Spinner from "../components/Spinner/Spinner";

function Articel() {
  const { blogId } = useParams();

  const { data, isLoading } = useQuery(["article", blogId], () =>
    fetchData("blog", blogId)
  );

  const [companyData, setCompany] = React.useState([]);
  const [authorData, setAuthorData] = React.useState([]);

  React.useEffect(() => {
    if (data?.ticker) {
      fetchData("company", data?.ticker)
        .then((response) => {
          setCompany(response);
        })
        .catch((error) => {});
    }
    if (data?.author) {
      fetchData("authors", data?.author)
        .then((response) => {
          setAuthorData(response);
        })
        .catch((error) => {});
    }
  }, [data?.ticker, data?.author]);

  if (isLoading) return <Spinner />;

  return (
    <BlogPost
      data={data}
      meta={companyData}
      author={authorData}
      showInfo={true}
      category="blog"
    />
  );
}

export default Articel;
